import { getUserGroup } from '@hb/shared'
import { useMemo } from 'react'
import { useApp } from '../../contexts/AppContext'
import { useAuth } from '../../store/auth'

export const useUserGroup = () => {
  const { appName } = useApp()
  const { admin } = useAuth()
  const userGroup = useMemo(() => getUserGroup(appName, admin), [appName, admin])
  return userGroup
}
